import React, { useState } from 'react'
import { format } from 'date-fns'
import { graphql, Link, useStaticQuery } from 'gatsby'

// Components
import ChevronRight from './svg/chevronRight'

const PastAuctions = () => {
  const data = useStaticQuery(graphql`
    {
      allPastAuctionsJson(sort: { information: { auction: { endsAt: DESC } } }, filter: { information: { auction: { status: { ne: "ARCHIVED" } } } }) {
        edges {
          node {
            information {
              auction {
                auctionEndTime: endsAt
                auctionId: id
                auctionTitle: title
                auctionUuid: uuid
              }
            }
          }
        }
      }
      prismicConfig {
        _previewable
        data {
          search
        }
        id
        prismicId
      }
    }
  `)
  const [searchText, setSearchText] = useState('')
  const filteredItems = data.allPastAuctionsJson.edges.filter((auction) => auction.node.information.auction.auctionTitle.toLowerCase().includes(searchText.toLowerCase()))
  const titleMap = new Map()
  return (
    <section className='component-past_auctions mx-auto max-w-screen-xl p-6'>
      <div className='sm:rounded-t-xl bg-white shadow-sm w-full ring-1 ring-gray-900/5 p-4'>
        <label className='inline-block mb-2 font-semibold text-gray-900' htmlFor='search'>
          {data.prismicConfig.data.search}
        </label>
        <input
          type='search'
          name='search'
          id='search'
          className='w-full rounded border-gray-900/20'
          placeholder={data.prismicConfig.data.search}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      <ul className='divide-y divide-gray-100 overflow-hidden bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-b-xl'>
        {filteredItems.map((auction) => {
          auction = auction.node.information.auction

          // Generate base slug
          let basePath = auction.auctionTitle
            .toLowerCase()
            .replace(/ /g, '-') // Replace spaces with hyphens
            .replace(/[^a-zA-Z0-9-]/g, '') // Remove special characters except hyphens
            .replace(/-+/g, '-') // Replace multiple hyphens with a single hyphen

          let safePath = basePath
          let count = titleMap.get(basePath) || 0

          if (count > 0) {
            safePath = `${basePath}-${count}`
          }

          titleMap.set(basePath, count + 1)

          const prettyURL = `/past-auctions/${safePath}/`

          return (
            <li key={auction.auctionId} className='relative flex gap-x-6 px-4 py-5 hover:bg-gray-50 sm:px-6 lg:px-8'>
              <div className='flex-1'>
                <Link to={prettyURL}>
                  <span className='absolute inset-x-0 -top-px bottom-0' />
                  <span dangerouslySetInnerHTML={{ __html: auction.auctionTitle }} />
                </Link>
              </div>
              <div className='text-gray-400'>{format(new Date(auction.auctionEndTime), 'do MMMM yyyy')}</div>
              <div>
                <ChevronRight className='h-5 w-5 flex-none text-gray-400' aria-hidden='true' />
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}

export default PastAuctions
